module.exports = __webpack_public_path__ + "img/preview_image.576f7430.jpg";